import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Variwide from "highcharts/modules/variwide";

// Initialize the variwide module
Variwide(Highcharts);

const DrugProceduresChart = () => {
  const rawData = [
    ["COVID-19 Infusion Therapy", 1.45, 50.0],
    ["Contrast Agents/Diagnostic Imaging", 0.0, 100],
    ["Additional Miscellaneous Drugs", 5.41, 100],
    ["Chemotherapy Anti-emetic Medications", 39.78, 50.0],
    ["Miscellaneous Drugs and Tests", 0.0, 100],
    ["Skin Substitutes and Biologicals", 3.73, 100],
    ["Cancer, Vision and Other Associated Drugs", 4.88, 100],
    ["Other Drugs and Test", 10.58, 99.79],
  ];

  const [filter1, setFilter1] = useState("Option A");
  const [filter2, setFilter2] = useState("Option X");
  const [filter3, setFilter3] = useState("2024");

  //   ["Surgical Procedures on the Integumentary System", 333.13, 142.33],
  //   ["Surgical Procedures on the Integumentary System", 333.13, 140.33],
  //   ["Surgical Procedures on the Endocrine System", 6.47, 166.81],
  //   ["Surgical Procedures on the Endocrine System", 6.47, 168.8],
  //   ["Preventive Medicine Services", 292.62, 120.01],
  //   ["Ophthalmology Services and Procedures", 277.79, 132.62],
  //   ["Neurology and Neuromuscular Procedures", 127.73, 157.29],
  //   ["Surgical Procedures on the Endocrine System", 6.47, 167.41],
  //   ["Ophthalmology Services and Procedures", 277.79, 127.73],
  //   ["Ophthalmology Services and Procedures", 277.79, 132.8],
  //   ["Surgical Procedures on the Integumentary System", 333.13, 140.44],
  //   ["Surgical Procedures on the Endocrine System", 6.47, 168.35],
  //   ["Preventive Medicine Services", 292.62, 120.84],
  //   ["Skin Substitutes and Biologicals", 10.59, 110.71],
  //   ["Neurology and Neuromuscular Procedures", 127.73, 154.89],
  //   ["Surgical Procedures on the Integumentary System", 333.13, 142.52],
  //   ["Preventive Medicine Services", 292.62, 86.76],
  //   ["Preventive Medicine Services", 292.62, 120.9],
  //   ["Surgical Procedures on the Endocrine System", 6.47, 169.63],
  //   ["Surgical Procedures on the Integumentary System", 333.13, 143.3],
  //   ["Preventive Medicine Services", 292.62, 121.76],
  //   ["Preventive Medicine Services", 292.62, 120.95],
  //   ["Surgical Procedures on the Integumentary System", 333.13, 144.96],
  //   ["Surgical Procedures on the Integumentary System", 333.13, 142.72],
  //   ["Skin Substitutes and Biologicals", 10.59, 110.71],
  //   ["Preventive Medicine Services", 292.62, 121.0],
  //   ["Surgical Procedures on the Endocrine System", 6.47, 168.36],
  //   ["Surgical Procedures on the Integumentary System", 333.13, 142.75],
  //   ["Skin Substitutes and Biologicals", 10.59, 110.99],
  //   ["Preventive Medicine Services", 292.62, 121.73],
  //   ["Vaccines, Toxoids", 67.12, 105.89],
  //   ["Preventive Medicine Services", 292.62, 120.15],
  //   ["Psychiatry Services and Procedures", 323.27, 109.94],
  //   ["Preventive Medicine Services", 292.62, 119.85],
  //   ["Surgical Procedures on the Integumentary System", 333.13, 142.52],
  //   ["Surgical Procedures on the Integumentary System", 333.13, 141.83],
  //   ["Vaccines, Toxoids", 67.12, 105.88],
  //   ["Surgical Procedures on the Endocrine System", 6.47, 168.91],
  //   ["Preventive Medicine Services", 292.62, 121.29],
  //   ["Preventive Medicine Services", 292.62, 120.89],
  //   ["Skin Substitutes and Biologicals", 10.59, 110.82],
  //   ["Skin Substitutes and Biologicals", 10.59, 110.71],
  //   ["Preventive Medicine Services", 292.62, 190.99],
  //   ["Surgical Procedures on the Integumentary System", 333.13, 141.82],
  //   ["Surgical Procedures on the Endocrine System", 6.47, 167.82],
  //   ["Surgical Procedures on the Endocrine System", 6.47, 168.38],
  //   ["Neurology and Neuromuscular Procedures", 127.73, 157.22],
  //   ["Preventive Medicine Services", 292.62, 120.84],
  //   ["Surgical Procedures on the Integumentary System", 333.13, 143.0],
  //   ["Skin Substitutes and Biologicals", 10.59, 110.71],
  //   ["Neurology and Neuromuscular Procedures", 127.73, 157.22],
  //   ["Preventive Medicine Services", 292.62, 96.41],
  //   ["Ophthalmology Services and Procedures", 277.79, 132.8],
  //   ["Surgical Procedures on the Endocrine System", 6.47, 168.92],
  //   ["Neurology and Neuromuscular Procedures", 127.73, 156.95],
  //   ["Ophthalmology Services and Procedures", 277.79, 132.69],
  //   ["Neurology and Neuromuscular Procedures", 127.73, 156.92],
  //   ["Surgical Procedures on the Endocrine System", 6.47, 167.84],
  //   ["Vaccines, Toxoids", 67.12, 134.97],
  //   ["Ophthalmology Services and Procedures", 277.79, 132.62],
  //   ["Surgical Procedures on the Endocrine System", 6.47, 168.35],
  //   ["Ophthalmology Services and Procedures", 277.79, 132.11],
  //   ["Ophthalmology Services and Procedures", 277.79, 132.62],
  //   ["General Surgical Procedures", 4.12, 101.47],
  //   ["Acupuncture Procedures", 50.39, 134.92],
  //   ["Newborn Care Services", 9.88, 118.13],
  //   ["Ophthalmology Services and Procedures", 277.79, 133.68],
  //   [
  //     "Central Nervous System Assessments/Tests (eg, Neuro-Cognitive, Mental Status, Speech Testing)",
  //     48.24,
  //     131.32,
  //   ],
  //   ["Acupuncture Procedures", 50.39, 104.78],
  //   ["Breast, Mammography", 140.65, 171.4],
  //   ["Other Medicine Services and Procedures", 13.44, 157.23],
  //   ["Care Management Services", 31.95, 83.96],
  //   ["Psychiatry Services and Procedures", 323.27, 109.92],
  //   ["Breast, Mammography", 140.65, 170.53],
  //   ["Office or Other Outpatient Services", 3018.99, 109.17],
  //   ["Care Management Services", 31.95, 97.84],
  //   ["Miscellaneous Services", 24.26, 137.36],
  //   ["Acupuncture Procedures", 50.39, 104.79],
  //   ["Psychiatry Services and Procedures", 323.27, 166.99],
  //   ["Diagnostic Radiology (Diagnostic Imaging) Procedures", 483.51, 215.25],
  //   ["Nursing Facility Services", 0.42, 91.21],
  //   ["Acupuncture Procedures", 50.39, 167.77],
  //   ["Office or Other Outpatient Services", 3018.99, 106.52],
  //   ["Diagnostic Radiology (Diagnostic Imaging) Procedures", 483.51, 214.41],
  // ];

  // const transformedData = rawData.map(([name, width, height]) => [
  //   name,
  //   height,
  //   width,
  // ]);

  // Width normalization function
  const getNormalizedWidth = (weight) => {
    if (weight <= 0) return 0.1;
    if (weight > 0 && weight <= 1) return 0.5;

    if (weight > 1 && weight <= 10) return 2;
    if (weight > 10 && weight <= 20) return 3;
    if (weight > 20 && weight <= 30) return 4;
    if (weight > 30 && weight <= 40) return 5;
    if (weight > 40 && weight <= 50) return 6;
    if (weight > 50 && weight <= 60) return 7;
    if (weight > 60 && weight <= 70) return 8;
    if (weight > 70 && weight <= 80) return 9;
    if (weight > 80 && weight <= 90) return 10;
    if (weight > 90 && weight <= 100) return 11;
    return 12;
  };

  // Transform raw data
  const transformedData = rawData.map(([name, weight, cost]) => ({
    name,
    y: cost,
    z: getNormalizedWidth(weight), // use normalized weight for width
    realWeight: weight, // store original for tooltip
  }));

  const colorPalette = [
    "#c0e7e7",
    "#507a8a",
    "#d1e8ff",
    "#ffd29f",
    "#f7bf9e",
    "#f7e6da",
    "#f4e7bb",
    "#c2e2ea",
    "#d7e3fc ",
  ];

  const options = {
    chart: {
      type: "variwide",
    },
    colors: colorPalette, // <-- Add this line
    title: {
      text: "%completeness and Medicare Weight",
    },
    subtitle: {
      text: "Variation of Width Range with legend ",
    },
    xAxis: {
      type: "category",
      labels: {
        enabled: false,
        // rotation: 0,
        // style: {
        //   fontFamily: "'Roboto Flex', serif !important",
        //   fontSize: "12px",
        //   whiteSpace: "nowrap",
        //   textOverflow: "ellipsis",
        //   fontSize: "12px",
        //   width: "100px",
        // },
      },
    },

    credits: { enabled: false },
    plotOptions: {
      variwide: {
        dataLabels: {
          enabled: true,
        },
      },

      series: {
        states: {
          hover: {
            enabled: false,
          },
        },
      },
    },
    // caption: {
    //   text: "Column widths are proportional to value (Z)",
    // },
    legend: {
      enabled: false,
    },

    series: [
      {
        name: "Cost",
        data: transformedData,

        tooltip: {
          pointFormat:
            "% Completeness: <b>{point.y}</b><br>Medicare Weight: <b>{point.realWeight}</b>",
        },
        borderRadius: 3,
        colorByPoint: true,
      },
    ],
  };

  return (
    <div
      className="bg-white p-4 "
      style={{ border: "none", borderRadius: "8px", margin: "0px 20px" }}
    >
      <div
        style={{
          marginBottom: "1rem",
          display: "flex",
          gap: "1rem",
          backgroundColor: "white",
          padding: "10px",
          borderRadius: "6px",
        }}
      >
        <div className="d-flex flex-column">
          <label className="form-label">Select Network:</label>
          <select
            value={filter1}
            onChange={(e) => setFilter1(e.target.value)}
            style={{
              width: "180px",
              backgroundColor: "white",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
            }}
          >
            <option>Select Network</option>
          </select>
        </div>
        <div className="d-flex flex-column">
          <label className="form-label">Select Category:</label>
          <select
            value={filter2}
            onChange={(e) => setFilter2(e.target.value)}
            style={{
              width: "180px",
              backgroundColor: "white",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
            }}
          >
            <option>Select Category</option>
          </select>
        </div>
        <div className="d-flex flex-column">
          <label className="form-label">Select Metrics:</label>
          <select
            value={filter3}
            onChange={(e) => setFilter3(e.target.value)}
            style={{
              width: "180px",
              backgroundColor: "white",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
            }}
          >
            <option>Select Metrics</option>
          </select>
        </div>
      </div>
      <HighchartsReact highcharts={Highcharts} options={options} />
      <div style={{ marginBottom: "1rem" }}>
        <ul
          style={{
            listStyle: "none",
            padding: 0,
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            justifyContent: "center",
          }}
        >
          {transformedData.map((item, index) => (
            <li
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontSize: "14px",
                fontFamily: "Roboto, sans-serif",
              }}
            >
              <span
                style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: colorPalette[index % colorPalette.length],
                  display: "inline-block",
                  borderRadius: "2px",
                }}
              />
              {item.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DrugProceduresChart;
